import { connect } from 'react-redux'
import {
  toggleDialog,
  saveSharingLink,
  loadSharingLinks,
  deleteSharingLink,
  types,
} from 'actions/sharing_links_actions'
import { createLoadingSelector } from 'libs/requests_status_handlers'

const loadingSelector = createLoadingSelector([types.SAVE_SHARING_LINK, types.DELETE_SHARING_LINK])

export default connect(
  (state) => ({
    dialogOpened: state.sharingLinks?.dialogOpened,
    currentLink: state.sharingLinks?.currentLink,
    successMessage: state.sharingLinks?.successMessage,
    errorMessage: state.sharingLinks?.errorMessage,
    links: state.sharingLinks?.links || [],
    isFetching: loadingSelector(state),
  }),
  {
    toggleDialog,
    saveSharingLink,
    loadSharingLinks,
    deleteSharingLink,
  }
)
